import { motion, useReducedMotion, type HTMLMotionProps } from 'framer-motion';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

interface Props extends HTMLMotionProps<'div'> {
  delay?: number;
}

export const MotionCard = forwardRef<HTMLDivElement, Props>(
  ({ className, delay = 0, children, ...props }, ref) => {
    const reduced = useReducedMotion();
    return (
      <motion.div
        ref={ref}
        initial={reduced ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25, ease: 'easeOut', delay }}
        className={cn(className)}
        {...props}
      >
        {children}
      </motion.div>
    );
  },
);
MotionCard.displayName = 'MotionCard';
